import React from "react";
import PropTypes from "prop-types";
import { Placeholder } from "react-bootstrap";
import { NoData } from "@components";
import { SectionAccordion } from "./SectionAccordion";
import styles from "./styles/Sidebar.module.css";

const placeholder = Array.from(Array(3).keys());

const Sidebar = (props) => {
  const { courseInfo, onChange, currentLesson, processing } = props;

  if (processing) {
    return (
      <Placeholder animation="glow" className="p-3">
        <div className="col">
          <Placeholder size="lg" xs={12} as="h4" />
        </div>
        {placeholder.map((val) => {
          return (
            <div key={val} className="p-3">
              <Placeholder size="lg" xs={12} className="mt-3" />
              <Placeholder xs={5} />
              <Placeholder xs={11} />
              <Placeholder xs={9} />
            </div>
          );
        })}
      </Placeholder>
    );
  }

  const { sections = [] } = courseInfo || {};
  if (!processing && (!courseInfo || !sections.length))
    return (
      <div className="h-100 d-flex align-items-center">
        <NoData className="border-0 bg-transparent" />
      </div>
    );

  return (
    <div className="placeholder-glow">
      <h5 className="p-3 m-0">Course content</h5>

      <div className={styles.listSection}>
        {sections.map((section) => {
          return (
            <SectionAccordion
              key={section.id}
              data={section}
              onChange={onChange}
              currentLesson={currentLesson}
            />
          );
        })}
      </div>
    </div>
  );
};

/* required: display name */
Sidebar.displayName = "Sidebar";

/* required: props types */
Sidebar.propTypes = {
  courseInfo: PropTypes.object,
  currentLesson: PropTypes.object,
  onChange: PropTypes.func,
  processing: PropTypes.bool,
};

/* required: default props */
Sidebar.defaultProps = {
  courseInfo: null,
  onChange: () => {},
  processing: false,
};

export { Sidebar };
